export const AGENT_LANGUAGES = {
	he: { name: "Hebrew", tier: 1, googleSpeechLocale: "iw-IL" },
	en: { name: "English", tier: 1, googleSpeechLocale: "en-US" },
	es: { name: "Spanish", tier: 2, googleSpeechLocale: "es-ES" },
	fr: { name: "French", tier: 2, googleSpeechLocale: "fr-FR" },
	de: { name: "German", tier: 2, googleSpeechLocale: "de-DE" },
	it: { name: "Italian", tier: 2, googleSpeechLocale: "it-IT" },
	ru: { name: "Russian", tier: 2, googleSpeechLocale: "ru-RU" },
	ar: { name: "Arabic", tier: 2, googleSpeechLocale: "ar-IL" },
} as const;

export type AgentLanguageCode = keyof typeof AGENT_LANGUAGES;

export const AGENT_LANGUAGE_CODES = Object.keys(
	AGENT_LANGUAGES,
) as AgentLanguageCode[];

export function normalizeAgentLanguageCode(
	language: string | null | undefined,
): AgentLanguageCode | null {
	const code = language?.trim().toLowerCase().split(/[-_]/)[0] || "";
	return Object.hasOwn(AGENT_LANGUAGES, code)
		? (code as AgentLanguageCode)
		: null;
}
